import LMSDispatcher from "../LMSDispatcher";

import { IApi, Api } from '../../utilities/Api';
import { ApiRequest } from '../../utilities/ApiRequest';
import * as ACTIONCONTANTS from './ActionConstants';
import InstrumentViewData, { IInstrumentViewData } from "../../models/instrument/InstrumentViewData";
import IInstrumentFormData from "../../models/instrument/InstrumentFormData";
import { IConnectFormData } from "../../models/device/ConnectFormData";
import IInstrumentSampleDetails from '../../models/instrument/InstrumentSampleData';
import { InstrumentSampleDetails } from '../../models/instrument/InstrumentSampleData';
import { SampleDetails, ISampleDetails } from "../../models/instrument/SampleDetails";
import i18next from "i18next";
import * as CONSTANTS from "../../utilities/Constants";
import utility from "../../components/shared/Utility";
class InstrumentActions {
    private readonly api: IApi;

    constructor() {
        this.api = new Api(ACTIONCONTANTS.SAMPLE_ENDPOINT);
    }

    async getById(id: string) {
        try {
            const request = new ApiRequest("/instrument/" + id, "", null, i18next.t("Instruments not found."));
            const result = await this.api.get(request);
            const payload = this.convertResponseData(result.data);
            LMSDispatcher.dispatch({
                type: ACTIONCONTANTS.INSTRUMENT_GET_BY_ID,
                payload: {
                    instrumentData: payload
                }
            });
        } catch (error) {
            throw error;
        }
    }

    async getSelected(id: string[]) {
        try {
            const request = new ApiRequest("/instrument/selected?ids=" + id.join('&ids='), "", null, i18next.t("Instruments not found."));
            const result = await this.api.get(request);
            const payload = this.convertResponseListData(result.data);

            LMSDispatcher.dispatch({
                type: ACTIONCONTANTS.INSTRUMENT_GET_ALL_SELECTED_ID,
                payload: {
                    instrumentDataList: payload
                }
            });
        } catch (error) {
            throw error;
        }
    }

    async getAll(status: boolean, page: number, pageSize: number, sort: string, order: string, filter: string) {
        try {
            const request = new ApiRequest(`/Instrument/${status}/${page}/${pageSize}/${sort}/${order}/${filter}`, "", null, i18next.t("Internal server error!"));
            const result = await this.api.get(request);
            const payload = this.convertResponseListData(result.data);
            LMSDispatcher.dispatch({
                type: ACTIONCONTANTS.INSTRUMENT_GET_ALL,
                payload: {
                    instrumentDataList: payload
                }
            });
        } catch (error) {
            throw error;
        }
    }

    async post(insData: IInstrumentFormData, devData: IConnectFormData): Promise<void> {
        try {
            const payload: any = this.preparePostPayload(insData, devData);
            const request = new ApiRequest("/instrument/", insData.requestId, payload, i18next.t("Instrument created."));
            const result = await this.api.post(request);

            LMSDispatcher.dispatch({
                type: ACTIONCONTANTS.INSTRUMENT_SUBMIT,
                payload: {
                    instrumentId: result.data,
                    message: result.message
                }
            });
        } catch (error) {
            throw error;
        }
    }

    async put(insData: IInstrumentFormData, devData: IConnectFormData, mappedProperties: any): Promise<void> {
        try {
            const payload: any = this.preparePutPayload(insData, devData, mappedProperties);
            const request = new ApiRequest("/instrument/", insData.requestId, payload, i18next.t("Instrument updated."));
            const result = await this.api.put(request);
            LMSDispatcher.dispatch({
                type: ACTIONCONTANTS.INSTRUMENT_SUBMIT,
                payload: {
                    instrumentId: payload.id,
                    message: result.message
                }
            });

        } catch (error) {
            throw error;
        }
    }

    async deleteMultiple(ids: any[], requestId: string): Promise<void> {
        try {
            const request = new ApiRequest("/instrument", requestId, ids, i18next.t("Instrument deleted"));
            const result = await this.api.deleteAll(request);
            LMSDispatcher.dispatch({
                type: ACTIONCONTANTS.INSTRUMENT_DELETE,
                payload: {
                    reload: true,
                    message: result.message
                }
            });
        } catch (error) {
            throw error;
        }
    }

    async enable(id: string, requestId: string): Promise<void> {
        try {
            const request = new ApiRequest("/instrument/" + id + "/enable", requestId, undefined, i18next.t("Instrument enabled"));
            const result = await this.api.patch(request);
            LMSDispatcher.dispatch({
                type: ACTIONCONTANTS.INSTRUMENT_ENABLE,
                payload: {
                    reload: true,
                    messages: result.message
                }
            });
        } catch (error) {
            throw error;
        }
    }

    async disable(id: string, requestId: string): Promise<void> {
        try {
            const request = new ApiRequest("/instrument/" + id + "/disable", requestId, undefined, i18next.t("Instrument disabled"));
            const result = await this.api.patch(request);
            LMSDispatcher.dispatch({
                type: ACTIONCONTANTS.INSTRUMENT_DISABLE,
                payload: {
                    reload: true,
                    messages: result.message
                }
            });
        } catch (error) {
            throw error;
        }
    }

    async checkDuplicateIP(ipAddress: string, port: number, id: any, requestId: any, isIp: boolean = false) {
        try {
            const request = new ApiRequest(`/Instrument/CheckDuplicate`, requestId, 
            {address: ipAddress, port: port, isIp: isIp, id:id},
            i18next.t("Duplicate IP Address!"));
            const result = await this.api.post(request);
            LMSDispatcher.dispatch({
                type: ACTIONCONTANTS.INSTRUMENT_CHECK_DUPLICATE_IP,
                payload: {
                    isDuplicateIp: result.data,
                    messages: result.message
                }
            });
        } catch (error) {
            throw error;
        }
    }
    async getSampleInstrumentDetails(id: string) {
        try {
            const request = new ApiRequest("/InstrumentMeasurement/instrument/" + id + "/measurement/details", "", null, i18next.t("Unable to fetch measurement data."));
            const result = await this.api.get(request);

            const data = this.convertInstrumentResponseData(result?.data)
            LMSDispatcher.dispatch({
                type: ACTIONCONTANTS.GET_INSTRUMENT_SAMPLE_DETAILS,
                payload: {
                    data
                }
            });
        } catch (error) {
            throw error.message;
        }
    }

    async getPropertyDetails() {
        try {
            const request = new ApiRequest("/property/GetAllPropertyDetails", "", null, i18next.t("Unable to fetch property data."));
            const data = await this.api.get(request);
            LMSDispatcher.dispatch({
                type: ACTIONCONTANTS.INSTRUMENT_GET_PROPERTY_DETAIL,
                payload: {
                    data
                }
            });
        } catch (error) {
            throw error.message;
        }
    }

    async checkPropertyInUse(propertyId:any) {
        try {
            const request = new ApiRequest(`/property/CheckPropertyBeingUsed/${propertyId}`, "", null, i18next.t("Unable to fetch property data."));
            const data = await this.api.get(request);
            LMSDispatcher.dispatch({
                type: ACTIONCONTANTS.INSTRUMENT_CHECK_PROPERTY_IN_USE,
                payload: {
                    data
                }
            });
        } catch (error) {
            throw error.message;
        }
    }

    convertInstrumentResponseData(data: any): IInstrumentSampleDetails {
        const sampleDetails: ISampleDetails[] = [];
        if(data){
        data.sampleDetails.forEach((element: any) => {
            sampleDetails.push(new SampleDetails(element.id, element.name, element.count, element?.directionCounts,
                element.properties, element?.readings, data?.instrumentStatus, element?.positionCounts, element?.statistics,
                element?.propertyMeans, element?.positionMeans,data?.isAutoLine,element?.testPlan, element?.measurementId, element?.instrumentSampleStatus));
        });
    }
        return new InstrumentSampleDetails(data?.id, data?.name, data?.description, data?.isEnabled,
            data?.measurementId, data?.orderId, data?.sampleDate, data?.setId, sampleDetails,data?.instrumentStatus);
    }

    private preparePostPayload(instrumentData: IInstrumentFormData, deviceData: IConnectFormData): any {
        const connectionData = {
            ipAddress: deviceData.ipAddress,
            port: deviceData.port,
            pollingFrequency: deviceData.pollingFrequency,
            username: deviceData.username,
            password: deviceData.password,
            path: deviceData.path,
            directory: deviceData.dir,
            isAutoLine: deviceData.isAutoLine,
            connectionId: deviceData.connectionId,
            connectionTypeId: deviceData.connectionTypeId
        }
        const directions: any[] = [];
        instrumentData.directions.forEach((element,index) => {
            directions.push({id: element.id,order:index});
        });

        const properties: any[] = [];
        instrumentData.properties.forEach(element => {
            if(element.id.toString() === element.customId.toString()){
                element.id = CONSTANTS.DefaultGuid
            }
            element.direction.forEach((dir) => {
                properties.push({
                    id: element.id ? element.id : CONSTANTS.DefaultGuid,
                    name: element.name,
                    instrumentPropertyId: element.instrumentPropertyId,
                    instrumentPropertyName: element.instrumentPropertyName,
                    directionId: dir.id,
                    max: element.max === "" ? null : element.max,
                    min: element.min === "" ? null : element.min,
                    customId: element.customId,
                    unit: element.unit,
                    decimals: element.decimals,
                    description: element.description,
                    uniqueId: element.uniqueId ? element.uniqueId : CONSTANTS.DefaultGuid,
                });
            })
        });
        return {
            name: instrumentData.name,
            codeId: instrumentData.codeId,
            serialNumber: instrumentData.serialNumber,
            instrumentType: {
                id: instrumentData.instrumentType.id,
                name: instrumentData.instrumentType.name
            },
            connection: connectionData,
            directions,
            properties,
            description: instrumentData.description,
            isCreatedManually: instrumentData.isCreatedManually
        };
    }

    private preparePutPayload(instrumentData: any, deviceData: IConnectFormData, mappedProperties: any): any {
        const connectionData = {
            ipAddress: deviceData.ipAddress,
            port: deviceData.port,
            pollingFrequency: deviceData.pollingFrequency,
            username: deviceData.username,
            password: deviceData.password,
            path: deviceData.path,
            directory: deviceData.dir,
            isAutoLine: deviceData.isAutoLine,
            connectionId: deviceData.connectionId,
            connectionTypeId: deviceData.connectionTypeId
        }
        const directions: any[] = [];
        instrumentData.directions.forEach((element: any, index:number) => {
            directions.push({id:element.id,order:index});
        });
        mappedProperties.map((i:any) => {
            i.selectedDirectionList = [];
            i.selectedDirection.map((x:any) => {
                i.selectedDirectionList.push(x.value)
            })
            i.selectedDirectionList = i.selectedDirectionList.filter((z:any,index:any) => {
                return i.selectedDirectionList.indexOf(z) === index
            })
        })
        let properties: any[] = [];
        instrumentData.properties.forEach((element: any) => {
            let editedProperty: any = [];
            editedProperty = mappedProperties.filter((i:any) => element.customId === i.customId)
            if (Array.isArray(element.direction)) {
                element.direction.map((dir: any) => {
                    properties.push({
                        id: element.id ? element.id : CONSTANTS.DefaultGuid,
                        name: element.name,
                        instrumentPropertyId: element.instrumentPropertyId,
                        instrumentPropertyName: element.instrumentPropertyName,
                        directionId: dir.id,
                        max: element.max === "" ? null : element.max,
                        min: element.min === "" ? null : element.min,
                        customId: element.customId,
                        unit: element.unit,
                        decimals: element.decimals,
                        description: element.description,
                        uniqueId: element.uniqueId ? element.uniqueId : CONSTANTS.DefaultGuid,
                        selectedDirection: editedProperty[0].selectedDirectionList
                    });
                })
            } else {
                properties.push({
                    id: element.id ? element.id : CONSTANTS.DefaultGuid,
                    name: element.name,
                    instrumentPropertyId: element.instrumentPropertyId,
                    instrumentPropertyName: element.instrumentPropertyName,
                    directionId: element.direction.id,
                    max: element.max === "" ? null : element.max,
                    min: element.min === "" ? null : element.min,
                    customId: element.customId,
                    unit: element.unit,
                    decimals: element.decimals,
                    description: element.description,
                    uniqueId: element.uniqueId ? element.uniqueId : CONSTANTS.DefaultGuid,
                    selectedDirection: editedProperty[0].selectedDirectionList
                });
            }
        });
        properties = properties.length !== 0 ? utility.removeDuplicatefromArrayBasedOncustomId(properties) : []
        return {
            id: instrumentData.id,
            name: instrumentData.name,
            codeId: instrumentData.codeId,
            serialNumber: instrumentData.serialNumber,
            instrumentType: {
                id: instrumentData.instrumentType.id,
                name: instrumentData.instrumentType.name
            },
            connection: connectionData,
            directions,
            properties,
            description: instrumentData.description,
            isCreatedManually: instrumentData.isCreatedManually
        };
    }

    private convertResponseData(data: any): IInstrumentViewData {
        return new InstrumentViewData(data.id, data.name, data.codeId, data.serialNumber, data.type, data.status, data.directions, data.isEnabled,
            data.isCreatedManually, data.description, data.properties, data.isAutoLine, data.isAssociated, data?.instrumentStation, [], data.connectionType, data.ipAddress, data.port, data.directory,  data.propertiesCount , data.createdOn);
    }

    private convertResponseListData(data: any) {
        const result: IInstrumentViewData[] = [];
        if (data.contents) {
            data.contents.forEach((element: any) => {
                result.push(this.convertResponseData(element));
            });
        } else {
            data.forEach((element: any) => {
                result.push(this.convertResponseData(element));
            });
        }
        const tempResult = {
            result : data.contents ? result : result,
            currentPage: data.contents ? data.currentPage : 0,
            totalPages: data.contents ?  data.totalPages : 0,
            totalRecords: data.contents ?  data.totalRecords : 0
        }
        return tempResult;
    }

}


const instrumentActions = new InstrumentActions();
export default instrumentActions;